<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

const props = defineProps({
  selectedCampaign: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['close']);

const store = useStore();
const isOpen = ref(false);
const isDeleting = ref(false);

const open = () => {
  isOpen.value = true;
};

const close = () => {
  isOpen.value = false;
  emit('close');
};

const deleteCampaign = async () => {
  if (!props.selectedCampaign?.id) {
    close();
    return;
  }
  isDeleting.value = true;
  try {
    await store.dispatch('campaigns/delete', props.selectedCampaign.id);
    useAlert('Campanha excluída com sucesso!');
    await store.dispatch('campaigns/get');
    close();
  } catch (error) {
    useAlert('Erro ao excluir campanha.');
  } finally {
    isDeleting.value = false;
  }
};

defineExpose({
  open,
  close,
  dialogRef: {
    open,
    close,
  },
});
</script>

<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-md animate-fade-in"
    @click.self="close"
  >
    <div class="flex flex-col w-full max-w-md bg-white dark:bg-n-solid-2 rounded-2xl shadow-2xl border border-n-weak overflow-hidden p-6 gap-5">
      <div class="flex items-center gap-3.5">
        <div class="size-12 rounded-2xl bg-rose-500/15 text-rose-600 dark:text-rose-400 flex items-center justify-center flex-shrink-0">
          <svg class="size-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </div>
        <div class="flex flex-col">
          <h3 class="text-base font-bold text-n-slate-12">
            Excluir Campanha
          </h3>
          <p class="text-xs text-n-slate-11">
            Tem certeza de que deseja excluir <b class="text-n-slate-12">"{{ selectedCampaign?.title }}"</b>? Esta ação não pode ser desfeita.
          </p>
        </div>
      </div>

      <div class="flex items-center justify-end gap-3 pt-2">
        <button
          type="button"
          class="px-4 py-2 rounded-xl text-xs font-semibold bg-slate-200 dark:bg-n-solid-3 hover:bg-slate-300 dark:hover:bg-n-solid-4 text-n-slate-12 transition-all"
          :disabled="isDeleting"
          @click="close"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="px-4 py-2 rounded-xl text-xs font-bold bg-rose-600 hover:bg-rose-700 active:scale-95 text-white transition-all shadow-sm flex items-center gap-2"
          :disabled="isDeleting"
          @click="deleteCampaign"
        >
          <span v-if="isDeleting" class="size-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" />
          <span>{{ isDeleting ? 'Excluindo...' : 'Sim, Excluir' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>
